// extracted by mini-css-extract-plugin
export default {"blockGroup":"FactorGroup_blockGroup__-9vhT","titleCard":"FactorGroup_titleCard__3EBY-","title":"FactorGroup_title__ErFhY","factorsContainer":"FactorGroup_factorsContainer__yuSPF"};